<div class="hiw-row-bakery">
  <div class="hiw-col-bakery hiw-col-img">
    <img class="hiw-bakery-img" [src]="bakery.image | multiUrlImage: 'small' : ''">
  </div>
  <div class="hiw-col-bakery hiw-col-info text-center">
    <div class="fw-bold font-xl">{{bakery.name}}</div>
    <div class="font-md">
      {{cities}}
      <span class="cursor-pointer fw-bold" *ngIf="isOverflow && !isExpand"
            (click)="toggleExpand()">
        {{'modal.howItWorks.showMoreCities' | translate: {count: bakery?.cities?.length - minForDisplay} }}
      </span>
      <span class="cursor-pointer fw-bold" *ngIf="isOverflow && isExpand"
            (click)="toggleExpand()"
            [translate]="'modal.howItWorks.hideCities'">hide</span>
    </div>
  </div>
  <div class="hiw-col-bakery hiw-col-deadline font-md">
    <ui-deadlines-info [deadlines]="deadlineRules"></ui-deadlines-info>
  </div>
  <div class="hiw-col-bakery hiw-col-action">
    <a class="btn btn-pink"
      [href]="navigate.getLocationUrl(bakery)"
      (click)="$event.preventDefault(); navigate.switchToDifferentLocation(bakery);"
      [translate]="'modal.howItWorks.seeAndOrderCakes'">
      Se og bestill kaker
    </a>
  </div>
</div>
